module.exports = __webpack_public_path__ + "static/online1-f1c61a2322e9829dbb6bcff64225937a.png";